<div class="tw-bg-white -tw-m-4 tw-p-6 tw-text-center tw-font-body">
  <div class="tw-text-500 tw-font-bold tw-mb-2" i18n="@@discontinuedInfoCantAddToCart">Can't add this to cart</div>
  <div class="tw-text-200 tw-text-gray-700" i18n="@@discontinuedInfoProductUnavailable">This product is currently unavailable for purchase.</div>
  <div class="tw-mt-6 tw-bg-teal-600 tw-text-white tw-rounded-2 tw-h-10 tw-flex tw-justify-center tw-items-center"
       (click)="onClose()" i18n="@@ok">Ok</div>
</div>

